/**
 * Liste sayfalarında (anasayfa, koleksiyon, arama) kaydırma konumunu saklar;
 * ürüne gidip tarayıcı "Geri" ile dönünce aynı yere kaydırır.
 * Koleksiyonda infinite / load more: sayfa yüksekliği sonradan büyür — ResizeObserver ile hedefe kadar takip edilir.
 */
(function () {
  const STORAGE_PREFIX = 'nodus:listScroll:';
  const LIST_RE = /\btemplate-(index|collection|list-collections|search)\b/;

  const isListPage = () => {
    const b = document.body;
    return !!(b && LIST_RE.test(b.className));
  };

  const storageKey = () => STORAGE_PREFIX + location.pathname + location.search;

  const isBackForwardNavigation = () => {
    const entries = typeof performance.getEntriesByType === 'function' ? performance.getEntriesByType('navigation') : [];
    const nav = entries[0];
    if (nav && nav.type === 'back_forward') return true;
    try {
      if (performance.navigation && performance.navigation.type === 2) return true;
    } catch (e) {
      /* ignore */
    }
    return false;
  };

  const readSavedScroll = (raw) => {
    if (raw == null || raw === '') return null;
    try {
      const o = JSON.parse(raw);
      if (o && typeof o.y === 'number' && !Number.isNaN(o.y)) {
        return { y: Math.max(0, Math.round(o.y)), page: typeof o.p === 'number' ? o.p : 1 };
      }
    } catch (e) {
      /* legacy: plain number */
    }
    const n = parseInt(raw, 10);
    if (Number.isNaN(n) || n < 0) return null;
    return { y: n, page: 1 };
  };

  const getAjaxCollectionContext = () => {
    const grid = document.querySelector('#ProductGridContainer .load-more-grid');
    const totalEl = document.querySelector('#ProductGridContainer input[data-total-pages]');
    if (!grid || !totalEl) return { ajax: false, totalPages: 1, loadedPage: 1 };
    const totalPages = parseInt(totalEl.value, 10) || 1;
    const curEl = document.querySelector('#ProductGridContainer input[data-current-page]');
    const loadedPage = curEl ? parseInt(curEl.value, 10) || 1 : 1;
    return { ajax: totalPages > 1, totalPages, loadedPage };
  };

  window.addEventListener(
    'pagehide',
    () => {
      const b = document.body;
      if (!b || !LIST_RE.test(b.className)) return;
      const y = Math.max(0, Math.round(window.scrollY));
      const ctx = getAjaxCollectionContext();
      const payload = ctx.ajax ? JSON.stringify({ y, p: ctx.loadedPage }) : String(y);
      try {
        sessionStorage.setItem(storageKey(), payload);
      } catch (e) {
        /* private mode / quota */
      }
    },
    { capture: true }
  );

  let restoreScheduled = false;

  const maxScrollY = () => Math.max(0, document.documentElement.scrollHeight - window.innerHeight);

  const scrollToClamped = (targetY) => {
    const html = document.documentElement;
    const prev = html.style.scrollBehavior;
    html.style.scrollBehavior = 'auto';
    window.scrollTo(0, Math.min(targetY, maxScrollY()));
    html.style.scrollBehavior = prev;
  };

  const shouldUseLayoutFollow = (targetY, saved) => {
    const ctx = getAjaxCollectionContext();
    if (!ctx.ajax) return false;
    if (saved.page > 1) return true;
    const vh = window.innerHeight || 800;
    return targetY > vh * 1.25;
  };

  const runBurst = (fn) => {
    fn();
    queueMicrotask(fn);
    requestAnimationFrame(() => {
      fn();
      requestAnimationFrame(fn);
    });
    [0, 20, 56, 120].forEach((ms) => setTimeout(fn, ms));
  };

  const tryRestore = () => {
    if (restoreScheduled || !isListPage() || !isBackForwardNavigation()) return;

    let raw;
    try {
      raw = sessionStorage.getItem(storageKey());
    } catch (e) {
      return;
    }

    const saved = readSavedScroll(raw);
    if (!saved) return;

    const targetY = saved.y;
    restoreScheduled = true;

    const follow = shouldUseLayoutFollow(targetY, saved);

    if (!follow) {
      const apply = () => scrollToClamped(targetY);
      runBurst(apply);
      return;
    }

    const EPS = 6;
    let ro = null;
    let stopTimer = 0;
    let roRaf = 0;
    let finished = false;

    const stop = () => {
      if (finished) return;
      finished = true;
      if (ro) {
        ro.disconnect();
        ro = null;
      }
      if (stopTimer) {
        clearTimeout(stopTimer);
        stopTimer = 0;
      }
    };

    const tick = () => {
      if (finished) return;
      const maxY = maxScrollY();
      scrollToClamped(targetY);
      if (maxY >= targetY - EPS) {
        const want = Math.min(targetY, maxY);
        if (Math.abs(window.scrollY - want) <= EPS) {
          stop();
        }
      }
    };

    const onResize = () => {
      if (roRaf) return;
      roRaf = requestAnimationFrame(() => {
        roRaf = 0;
        tick();
      });
    };

    tick();
    runBurst(tick);

    if (typeof ResizeObserver === 'function') {
      ro = new ResizeObserver(onResize);
      ro.observe(document.documentElement);
    }

    stopTimer = setTimeout(stop, 11000);
  };

  window.addEventListener('pageshow', (ev) => {
    if (ev.persisted) return;
    tryRestore();
  });

  window.addEventListener('load', tryRestore);
})();

(function () {
  const updateCartNoteCounter = (textarea) => {
    if (!(textarea instanceof HTMLTextAreaElement) || !textarea.closest('cart-note')) return;
    const maxAttr = textarea.getAttribute('maxlength');
    const max = maxAttr != null && maxAttr !== '' ? parseInt(maxAttr, 10) : 200;
    if (Number.isNaN(max) || max < 1) return;
    const root = textarea.closest('cart-note');
    const counter = root && root.querySelector('[data-cart-note-counter]');
    if (!counter) return;
    const n = textarea.value.length;
    const curEl = counter.querySelector('[data-cart-note-counter-current]');
    const maxEl = counter.querySelector('[data-cart-note-counter-max]');
    if (curEl) curEl.textContent = String(n);
    if (maxEl) maxEl.textContent = String(max);
    counter.classList.toggle('cart-note__counter--at-limit', n >= max);
  };

  const syncAllCartNoteCounters = (root) => {
    const scope = root && typeof root.querySelectorAll === 'function' ? root : document;
    for (const ta of scope.querySelectorAll('cart-note textarea[maxlength]')) {
      updateCartNoteCounter(ta);
    }
  };

  document.addEventListener('input', (e) => {
    const t = e.target;
    if (t instanceof HTMLTextAreaElement && t.closest('cart-note') && t.hasAttribute('maxlength')) {
      updateCartNoteCounter(t);
    }
  });

  document.addEventListener('DOMContentLoaded', () => syncAllCartNoteCounters(document));

  document.addEventListener('shopify:section:load', (e) => {
    if (e && e.target) syncAllCartNoteCounters(e.target);
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => syncAllCartNoteCounters(document));
  }
})();
